import React, {Fragment, useState} from 'react'


// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem'
import Tooltip from '@material-ui/core/Tooltip'
import Typography  from "@material-ui/core/Typography"
import Hidden from "@material-ui/core/Hidden"

// Material-UI Icon
import Menu from '@material-ui/core/Menu'
import Translate from '@material-ui/icons/Translate'
import ExpandMore from '@material-ui/icons/ExpandMore'

// Custom Component
import {AppBarButton} from '../../styles/jss/components/button'

// Custom Style
import iconStyle from '../../styles/jss/components/iconStyle'


const SiteTypography = withStyles({
	root: {
		"fontSize": 16,
		"fontWeight": 600,
		"color": "#0000b3",
	},
}) (Typography)

const useStyles = makeStyles(iconStyle)


function LanguageButton() {
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <Fragment>
            <Hidden smDown>
				<Tooltip title='Change Language' aria-label='change_language'>
					<AppBarButton
						onClick={handleClick}
						startIcon={<Translate className={classes.iconProperties} />}
						endIcon={<ExpandMore className={classes.iconProperties} />}
					>
						<SiteTypography>English</SiteTypography>
					</AppBarButton>
				</Tooltip>
            </Hidden>

			<Hidden mdUp>
				<Tooltip title='Change Language' aria-label='change_language'>
					<IconButton  aria-controls='simple-menu' aria-haspopup='true' onClick={handleClick}>
						<Translate className={classes.iconProperties} />
					</IconButton>
				</Tooltip>
			</Hidden>

            <Menu
                id='langusge-menu'
                anchorEl={anchorEl}
                keepMounted

                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}

                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClose}>English</MenuItem>
                {/* <MenuItem onClick={handleClose}>中文</MenuItem> */}
            </Menu>
        </Fragment>
    )
}


// function LanguageIcon() {
//     const classes = useStyles()
//     const [anchorEl, setAnchorEl] = React.useState(null)

//     const handleClick = (event) => {
//         setAnchorEl(event.currentTarget)
//     }

//     const handleClose = () => {
//         setAnchorEl(null)
//     }

//     return (
//         <div>
//             <Tooltip title='Change Language' aria-label='change_language'>
//                 <IconButton  aria-controls='simple-menu' aria-haspopup='true' onClick={handleClick}>
//                     <Translate className={classes.iconProperties} />
//                 </IconButton>
//             </Tooltip>

//             <Menu
//                 id='Language-menu'
//                 anchorEl={anchorEl}
//                 keepMounted

//                 getContentAnchorEl={null}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//                 transformOrigin={{ vertical: 'top', horizontal: 'center' }}

//                 open={Boolean(anchorEl)}
//                 onClose={handleClose}
//             >
//                 <MenuItem onClick={handleClose}>English</MenuItem>
//                 <MenuItem onClick={handleClose}>中文</MenuItem>
//             </Menu>
//         </div>
//     )
// }


export default LanguageButton